import { PlaceholdersId, TFComponent } from '@types';
import { BankDocumentPlaceholder } from './bankDocument';

export const bankDocument: TFComponent = {
	component: BankDocumentPlaceholder,
	id: PlaceholdersId.bankDocument,
	name: 'bankDocument',
};
